/**
 * Products API service
 */

import { apiClient } from './client';
import type {
  Product,
  CreateProductRequest,
  UpdateProductRequest,
  SearchProductsQuery,
  ListProductsResponse,
  SearchOffResponse,
} from '@/types/api';

/**
 * GET /api/products
 * List saved products with optional filtering
 */
export async function getProducts(
  query: SearchProductsQuery = {},
): Promise<ListProductsResponse> {
  const response = await apiClient.get<ListProductsResponse>('/products', {
    params: query,
  });
  return response.data;
}

/**
 * GET /api/products/:id
 */
export async function getProductById(id: number): Promise<Product> {
  const response = await apiClient.get<Product>(`/products/${id}`);
  return response.data;
}

/**
 * POST /api/products
 */
export async function createProduct(
  data: CreateProductRequest,
): Promise<Product> {
  const response = await apiClient.post<Product>('/products', data);
  return response.data;
}

/**
 * PATCH /api/products/:id
 */
export async function updateProduct(
  id: number,
  data: UpdateProductRequest,
): Promise<Product> {
  const response = await apiClient.patch<Product>(`/products/${id}`, data);
  return response.data;
}

/**
 * DELETE /api/products/:id
 */
export async function deleteProduct(id: number): Promise<void> {
  await apiClient.delete(`/products/${id}`);
}

/**
 * GET /api/products/search/off
 * Search OpenFoodFacts (does not save locally)
 */
export async function searchOpenFoodFacts(
  query: string,
  page = 1,
  pageSize = 20,
): Promise<SearchOffResponse> {
  const response = await apiClient.get<SearchOffResponse>(
    '/products/search/off',
    { params: { query, page, pageSize } },
  );
  return response.data;
}
